import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-bank-id-button',
    templateUrl: './bank-id-button.component.html',
    styleUrls: ['./bank-id-button.component.scss'],
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BankIdButtonComponent implements OnChanges {
    public bgColor: string;
    public textColor: string;
    public borderColor: string;

    @Input() disabled: boolean = false;
    @Input() small: boolean = false;
    @Input() appearance: 'black' | 'white' = 'black';

    @Output() readonly verifyClick: EventEmitter<void> = new EventEmitter<void>();

    constructor() {
        this.setColors();
    }

    public ngOnChanges(): void {
        this.setColors();
    }

    public clicked(): void {
        if (!this.disabled) {
            this.verifyClick.emit();
        }
    }

    private setColors(): void {
        if (this.appearance === 'white') {
            this.bgColor = this.disabled ? '#f9fafb' : 'white';
            this.borderColor = this.disabled ? '#999999' : 'black';
            this.textColor = this.disabled ? '#999999' : 'black';
        } else {
            this.bgColor = this.disabled ? '#999999' : 'black';
            this.borderColor = this.disabled ? '#999999' : 'black';
            this.textColor = this.disabled ? '#e6e6e6' : 'white';
        }
    }
}
